import { Font, Text, View } from '@react-pdf/renderer'
import { IDadoGrafico2 } from '../..'
import NexaLight from '../../../../../assets/fonts/Nexa-Light.ttf'

Font.register({ family: 'Nexa Light', src: NexaLight })

const COR_DESTAQUE = '#48BB78'
const COR_ATENCAO = '#F4A261'
const COR_NEUTRA = '#8A8A8A'
const COR_GRADE = '#E5E7EB'
const COR_TEXTO = '#5A5A5A'
const TICKS = [-1, -0.5, 0, 0.5, 1]

interface iGraficoPDFProps {
  dados: IDadoGrafico2[]
  alturaLinha: number
  tamanhoFonte: number
  larguraNomes: number
}

export const GraficoPDF: React.FC<iGraficoPDFProps> = ({ dados, alturaLinha, tamanhoFonte, larguraNomes }) => {
  const ordenado = [...dados].sort((a, b) => parseFloat(b.media) - parseFloat(a.media))
  const alturaPlot = ordenado.length * alturaLinha
  const larguraPlot = 100 - larguraNomes - 4
  const topoTexto = (alturaLinha - tamanhoFonte * 1.2) / 2
  const texto = { fontFamily: 'Nexa Light', fontSize: tamanhoFonte, color: COR_TEXTO }
  const posicao = (v: number): number => (v + 1) / 2 * 100

  return (
    <View style={{ width: '100%' }}>
      <View style={{ flexDirection: 'row', justifyContent: 'center', marginLeft: `${larguraNomes}%`, width: `${larguraPlot}%`, marginBottom: 6 }}>
        <View style={{ flexDirection: 'row', alignItems: 'center', marginRight: 14 }}>
          <Text style={texto}>Pontos de atenção</Text>
          <View style={{ width: tamanhoFonte, height: tamanhoFonte, backgroundColor: COR_ATENCAO, marginLeft: 4 }} />
        </View>
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <View style={{ width: tamanhoFonte, height: tamanhoFonte, backgroundColor: COR_DESTAQUE, marginRight: 4 }} />
          <Text style={texto}>Destaques</Text>
        </View>
      </View>

      <View style={{ position: 'relative', height: alturaPlot + tamanhoFonte * 2 }}>
        <View style={{ position: 'absolute', left: 0, top: 0, width: `${larguraNomes}%` }}>
          {ordenado.map((e, i) => (
            <View key={i} style={{ height: alturaLinha, justifyContent: 'center' }}>
              <Text style={texto}>{e.nome}</Text>
            </View>
          ))}
        </View>

        <View style={{ position: 'absolute', left: `${larguraNomes}%`, width: `${larguraPlot}%`, top: 0, height: alturaPlot }}>
          {TICKS.map(t => (
            <View key={t} style={{ position: 'absolute', left: `${posicao(t)}%`, top: 0, width: t === 0 ? 1 : 0.5, height: alturaPlot, backgroundColor: t === 0 ? '#9CA3AF' : COR_GRADE }} />
          ))}
          {ordenado.map((e, i) => {
            const valor = parseFloat(e.media)
            const x = posicao(valor)
            const cor = valor === 0 ? COR_NEUTRA : e.melhoria ? COR_ATENCAO : COR_DESTAQUE
            const topo = i * alturaLinha
            return (
              <View key={i}>
                <View style={{ position: 'absolute', top: topo + alturaLinha * 0.15, height: alturaLinha * 0.7, left: `${Math.min(x, 50)}%`, width: valor === 0 ? 3 : `${Math.abs(x - 50)}%`, marginLeft: valor === 0 ? -1.5 : 0, backgroundColor: cor }} />
                {valor < 0
                  ? <Text style={{ ...texto, position: 'absolute', top: topo + topoTexto, right: `${100 - x}%`, marginRight: 4 }}>{e.media}</Text>
                  : <Text style={{ ...texto, position: 'absolute', top: topo + topoTexto, left: `${x}%`, marginLeft: 6 }}>{e.media}</Text>}
              </View>
            )
          })}
          {TICKS.map(t => (
            <Text key={t} style={{ ...texto, position: 'absolute', top: alturaPlot + 4, left: `${posicao(t)}%`, width: 30, marginLeft: -15, textAlign: 'center' }}>{t}</Text>
          ))}
        </View>
      </View>
    </View>
  )
}
